/*
 * 兼容性处理配置文件
 */

import sdk from './sdk';
import { versionCompare } from './common';

/**
 * @description: 视频加载兼容性处理方法，在v2.2.0之前的版本没有补偿视频（主视频加载失败之后的备选视频）
 */

const compatiblePreloadVideo = function (masterVideoData, fillVideoData) {
	console.log(`masterVideoData`, masterVideoData);
	console.log(`fillVideoData`, fillVideoData);
};
/**
 * @description: 视频加载兼容性处理方法，在v2.1.0之前的版本只接入了穿山甲视频，不给客户端传 video_type 字段
 * @return:
 */

const compatibleShowVideo = function (masterVideoData, fillVideoData) {
	return new Promise((resolve) => {
		console.log('compatibleShowVideo 2.2.0及以上版本');
		console.log(`masterVideoData`, masterVideoData);
		console.log(`fillVideoData`, fillVideoData);
		sdk.showRewardVideo(JSON.stringify(masterVideoData), JSON.stringify(fillVideoData));
		resolve({ code: 0 });
	});
};
/**
 * @description: 点击QQ群号，如果本地有安装QQ，则直接调起。在 Kuaiyin Android v2.1.0 之前的版本没有此功能
 * @return:
 */

const compatibleOpenQQQun = function (qq) {
	sdk.openPageWithJSON(JSON.stringify(qq));
};

/**
 * @description: 接入蛋蛋赚游戏。
 */

const compatibleOpenDanDanGame = function (task_url, task_type, advert_id) {
	let device_id = sdk.getDdIMEI();
	// let device_id = sdk.getIMEI();
	let data = {
		url: task_url,
		back_mode: 'close',
		on_show_refresh: true,
	};
	let arg;
	if (advert_id) {
		arg = {
			taskType: task_type,
			deviceId: device_id,
			adId: advert_id,
		};
	} else {
		arg = {
			taskType: task_type,
			deviceId: device_id,
		};
	}
	sdk.openPageWithJSON(JSON.stringify(data));
};

/**
 * @description: 接入梦工厂小游戏。在 Kuaiyin Android v2.2.0 之前的版本没有此功能
 */

const compatibleOpenMgcGame = function (task_url, task_type, game_id, game_scene) {
	let curClientVersion = sdk.getUserInfo()['client-v'];
	let curPlatformVersion = sdk.getUserInfo()['platform-v'];
	// 如果当前安卓版本号低于 2.1.0不调起
	if (versionCompare(curClientVersion, '2.1.0') == -1) {
		console.log(task_url);
		console.log('2.2.0 以前的版本，未接入');
	} else if (versionCompare(curClientVersion, '2.2.0') != -1 && Number(curPlatformVersion.split('.')[0]) >= 6) {
		// 如果当前 APP版本大于 2.2.0，并且安卓版本号大于 6.0.0，打开游戏
		console.log('2.2.0 及以上版本，打开梦工厂游戏页面');
		// 暂未对 game_id 和 game_scene 做处理，看后续需求
		let data = {
			url: task_url,
			sign: 'mgcgame',
		};
		console.log(data);
		sdk.openPageWithJSON(JSON.stringify(data));
	}
};
/**
 * @description: 接入阅盟小说。在 Kuaiyin Android v2.1.0 之前的版本没有此功能
 */

const compatibleOpenYueMeng = function (task_url) {
	let curClientVersion = sdk.getUserInfo()['client-v'];
	// 如果当前安卓版本号低于 2.1.0不调起
	if (versionCompare(curClientVersion, '2.1.0') == -1) {
		console.log(task_url);
		console.log('2.1.0 以前的版本，未接入');
	} else {
		console.log('2.1.0 及以上版本，打开小说页面');
		let data = {
			url: task_url,
		};
		sdk.openPageWithJSON(JSON.stringify(data));
	}
};

export { compatiblePreloadVideo };
export { compatibleShowVideo };
export { compatibleOpenQQQun };
export { compatibleOpenDanDanGame };
export { compatibleOpenYueMeng };
export { compatibleOpenMgcGame };



// WEBPACK FOOTER //
// ./src/lib/compatible.js